/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Card} from 'app/components/Ops'

const DashboardPage: FC = () => {
  return (
    <>
      {/* begin::Row */}
      <div className='row gy-5 g-xl-8'>
        <Card className='rounded-0'>
          <p className='mb-0 fs-4 text-center'>Selamat datang</p>
        </Card>
        {/* <div className='col-xxl-4'>
            <MixedWidget2
              className='card-xl-stretch mb-xl-8'
              chartColor='danger'
              chartHeight='200px'
              strokeColor='#cb1e46'
            />
          </div>
          <div className='col-xxl-4'>
            <ListsWidget5 className='card-xxl-stretch' />
          </div>
          <div className='col-xxl-4'>
            <MixedWidget10
              className='card-xxl-stretch-50 mb-5 mb-xl-8'
              chartColor='primary'
              chartHeight='150px'
            />
            <MixedWidget11
              className='card-xxl-stretch-50 mb-5 mb-xl-8'
              chartColor='primary'
              chartHeight='175px'
            />
          </div> */}
      </div>
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
